/* =========================================
   Anniversary Timeline JS (Shopify Asset)
   ========================================= */

function initTimelineEffects() {
    if (typeof gsap === 'undefined') {
        console.error('GSAP is not loaded.');
        return;
    }

    gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

    // 古いScrollTriggerが残っている場合はリセット（プレビューのリロード・再実行対策）
    ScrollTrigger.getAll().forEach(st => st.kill());

    const loader = document.getElementById('loader');
    const countEl = document.getElementById('loader-count');
    const heroStack = document.querySelector('.hero-stack');

    if (loader && countEl) {
        const counter = { val: 0 };
        const masterTl = gsap.timeline();

        function startHeroAnimations() {
            if (heroStack) {
                gsap.fromTo(heroStack,
                    { opacity: 0, y: 30 },
                    { opacity: 1, y: 0, duration: 1.5, ease: "power3.out" }
                );
            }
        }

        // Shopifyテーマエディタで編集中かどうかを判定
        const isEditorMode = window.Shopify && window.Shopify.designMode;

        if (isEditorMode) {
            // ▼ プレビュー中はカウントアップ演出を省略して即時非表示にする
            countEl.innerText = "45";
            gsap.set(loader, { display: "none" });
            startHeroAnimations();
        } else {
            // ▼ 通常時のカウント演出
            masterTl
                .to(counter, {
                    val: 45,
                    duration: 2,
                    ease: "power2.inOut",
                    onUpdate: () => {
                        countEl.innerText = Math.floor(counter.val);
                    }
                })
                .to(countEl, { scale: 1.2, duration: 0.2, ease: "power1.out" })
                .to(loader, {
                    yPercent: -100,
                    duration: 1,
                    ease: "power4.inOut"
                })
                .add(() => {
                    startHeroAnimations();
                }, "-=0.5");
        }
    } else {
        const heroStack = document.querySelector('.hero-stack');
        if (heroStack) gsap.set(heroStack, { opacity: 1, y: 0 });
    }

    const track = document.getElementById('hScrollTrack');
    const container = document.querySelector('.h-scroll-container');
    const cards = document.querySelectorAll('.h-card');
    const introCard = document.querySelector('.intro-card');

    if (!track || !container) return;

    const canvas = document.getElementById('ocean-particles');
    if (canvas) {
        const ctx = canvas.getContext('2d');
        let width = canvas.width = window.innerWidth;
        let height = canvas.height = window.innerHeight;

        const mouse = { x: null, y: null };
        const updateMouse = (x, y) => {
            mouse.x = x;
            mouse.y = y;
        };

        window.addEventListener('mousemove', (e) => updateMouse(e.clientX, e.clientY));

        window.addEventListener('touchstart', (e) => {
            if (e.touches.length > 0) updateMouse(e.touches[0].clientX, e.touches[0].clientY);
        }, { passive: true });

        window.addEventListener('touchmove', (e) => {
            if (e.touches.length > 0) updateMouse(e.touches[0].clientX, e.touches[0].clientY);
        }, { passive: true });

        window.addEventListener('touchend', () => updateMouse(null, null));
        window.addEventListener('touchcancel', () => updateMouse(null, null));


        const particles = [];
        const particleCount = 80;

        class Particle {
            constructor() {
                this.init(true);
            }

            init(firstRun = false) {
                this.x = Math.random() * width;
                this.y = firstRun ? Math.random() * height : height + Math.random() * 100;
                this.vx = Math.random() * 0.5 - 0.25;
                this.vy = Math.random() * -1 - 0.5;
                this.size = Math.random() * 15 + 3;
                this.alpha = Math.random() * 0.4 + 0.1;

                this.wobble = Math.random() * Math.PI * 2;
                this.wobbleSpeed = 0.02;
                this.pushX = 0;
                this.pushY = 0;
                this.friction = 0.95;
            }

            update() {
                this.y += this.vy + this.pushY;

                this.wobble += this.wobbleSpeed;
                this.x += (Math.sin(this.wobble) * 0.5) + this.pushX;

                this.pushX *= this.friction;
                this.pushY *= this.friction;

                if (mouse.x !== null) {
                    const dx = this.x - mouse.x;
                    const dy = this.y - mouse.y;
                    const dist = Math.sqrt(dx * dx + dy * dy);
                    const radius = 150;

                    if (dist < radius) {
                        const force = (radius - dist) / radius;
                        const strength = 0.5;
                        this.pushX += dx * force * strength * 0.05;
                        this.pushY += dy * force * strength * 0.05;
                    }
                }

                if (this.y < -50) this.init();
                if (this.x < -50 || this.x > width + 50) this.init();
            }

            draw() {
                ctx.beginPath();
                ctx.arc(this.x, this.y, this.size / 2, 0, Math.PI * 2);
                ctx.fillStyle = `rgba(255, 255, 255, ${this.alpha * 0.4})`;
                ctx.fill();

                ctx.strokeStyle = `rgba(255, 255, 255, ${this.alpha * 0.9})`;
                ctx.lineWidth = 1;
                ctx.stroke();
                ctx.beginPath();
                const highlightOffset = this.size * 0.15;
                const highlightSize = this.size * 0.15;
                ctx.arc(this.x - highlightOffset, this.y - highlightOffset, highlightSize, 0, Math.PI * 2);
                ctx.fillStyle = `rgba(255, 255, 255, ${this.alpha * 0.9})`;
                ctx.fill();
            }
        }

        for (let i = 0; i < particleCount; i++) {
            particles.push(new Particle());
        }

        function animateParticles() {
            ctx.clearRect(0, 0, width, height);
            particles.forEach(p => {
                p.update();
                p.draw();
            });
            requestAnimationFrame(animateParticles);
        }

        animateParticles();

        window.addEventListener('resize', () => {
            width = canvas.width = window.innerWidth;
            height = canvas.height = window.innerHeight;
            canvas.width = width;
            canvas.height = height;
        });
    }

    function getScrollAmount() {
        let trackWidth = track.scrollWidth;
        return trackWidth - window.innerWidth;
    }

    function getSnapPoints() {
        const cards = document.querySelectorAll('.h-card');
        const track = document.getElementById('hScrollTrack');
        if (!cards.length || !track) return [];

        const viewCenter = window.innerWidth / 2;
        const maxScroll = getScrollAmount();

        let points = [];
        cards.forEach(card => {
            const cardCenter = card.offsetLeft + card.offsetWidth / 2;
            // 目標: trackX + cardCenter = viewCenter
            // progress = (cardCenter - viewCenter) / maxScroll
            let progress = (cardCenter - viewCenter) / maxScroll;
            progress = Math.max(0, Math.min(1, progress));
            points.push(progress);
        });
        return points;
    }

    const horizontalTween = gsap.to(track, {
        x: () => -getScrollAmount(),
        ease: "none",
        scrollTrigger: {
            trigger: container,
            start: "top top",
            end: () => "+=" + getScrollAmount(),
            pin: true,
            scrub: true, // 追従の遅延をなくしてすぐにスナップ判定に入れるようにする
            invalidateOnRefresh: true,
            anticipatePin: 1,
            snap: {
                snapTo: (value) => {
                    const points = getSnapPoints();
                    return gsap.utils.snap(points, value);
                },
                duration: { min: 0.3, max: 0.6 }, // 少し滑らかな長さに調整
                delay: 0, // スクロール停止後、即座にスナップを開始
                ease: "power2.out" // 跳ね返り（back.out）ではなく、スッと止まる高級感のあるイージング
            },
            onUpdate: (self) => {
                updateGlobalTheme(self.progress);
            }
        }
    });

    function updateGlobalTheme(progress) {
        const globalBg = document.getElementById('global-bg');
        if (!globalBg) return;

        const startP = 0.5;
        const endP = 0.9;

        let p = (progress - startP) / (endP - startP);
        p = Math.max(0, Math.min(1, p)); // Clamp 0-1

        const r = Math.round(14 + (240 - 14) * p);
        const g = Math.round(46 + (244 - 46) * p);
        const b = Math.round(83 + (248 - 83) * p);

        globalBg.style.backgroundColor = `rgb(${r}, ${g}, ${b})`;

        const tr = Math.round(255 + (14 - 255) * p);
        const tg = Math.round(255 + (46 - 255) * p);
        const tb = Math.round(255 + (83 - 255) * p);
        const textColor = `rgb(${tr}, ${tg}, ${tb})`;

        const textElements = document.querySelectorAll(".h-card-year, .h-card-desc, .mosaic-title, .mosaic-item");
        textElements.forEach(el => el.style.color = textColor);
    }

    cards.forEach(card => {
        ScrollTrigger.create({
            trigger: card,
            containerAnimation: horizontalTween,
            start: "center 80%",
            end: "center 20%",
            onEnter: () => card.classList.add('active'),
            onLeave: () => card.classList.remove('active'),
            onEnterBack: () => card.classList.add('active'),
            onLeaveBack: () => card.classList.remove('active')
        });
    });

    const waveEdgeSvg = document.querySelector(".wave-edge svg");
    const waveRider = document.getElementById("wave-rider");

    if (waveEdgeSvg && waveRider) {
        gsap.to(waveEdgeSvg, {
            x: "-50%",
            duration: 12,
            repeat: -1,
            ease: "none",
            onUpdate: function () {
                const progress = this.progress();
                const amp = 25;
                const angle = progress * Math.PI * 2;
                const y = -Math.sin(angle) * amp;
                const rot = -Math.cos(angle) * 8;

                gsap.set(waveRider, { y: y, rotation: rot });
            }
        });
    }

    const ship = document.getElementById('timeline-ship');
    if (ship) {
        gsap.to(ship, {
            left: "100%",
            ease: "none",
            scrollTrigger: {
                trigger: container,
                start: "top top",
                end: () => "+=" + getScrollAmount(),
                scrub: 0.5
            }
        });
    }

    const compassContainer = document.querySelector('.compass-container');
    const compassNeedle = document.querySelector('.compass-needle');

    if (compassContainer) {
        ScrollTrigger.matchMedia({
            "(min-width: 769px)": function () {
                gsap.to(compassContainer, {
                    autoAlpha: 1, // opacity:1, visibility:visible
                    duration: 0.8,
                    ease: "power2.out",
                    scrollTrigger: {
                        trigger: ".h-scroll-container",
                        start: "top center+=300",
                        end: "bottom -=5000",
                        toggleActions: "play reverse play reverse",
                    }
                });
            },
            "(max-width: 768px)": function () {
                gsap.to(compassContainer, {
                    autoAlpha: 1,
                    duration: 0.8,
                    ease: "power2.out",
                    scrollTrigger: {
                        trigger: ".h-scroll-container",
                        start: "top 75%",
                        end: "bottom top-=2600",
                        toggleActions: "play reverse play reverse",
                    }
                });
            }
        });
    }

    if (compassNeedle) {
        gsap.to(compassNeedle, {
            rotation: 360 * 2,
            ease: "none",
            scrollTrigger: {
                trigger: "body",
                start: "top top",
                end: "bottom bottom",
                scrub: 1
            }
        });
    }

    // モザイクセクションのタイトルアニメーション（1文字ずつ下から上へ出現）
    function splitTextToSpans(sourceEl, targetEl) {
        Array.from(sourceEl.childNodes).forEach(node => {
            if (node.nodeType === Node.TEXT_NODE) {
                const text = node.textContent;
                for (let char of text) {
                    if (char.trim() === '') {
                        targetEl.appendChild(document.createTextNode(char));
                    } else {
                        const span = document.createElement('span');
                        span.className = 'char';
                        span.style.display = 'inline-block'; // transform用
                        span.textContent = char;
                        targetEl.appendChild(span);
                    }
                }
            } else if (node.nodeType === Node.ELEMENT_NODE) {
                const clone = node.cloneNode(false);
                targetEl.appendChild(clone);
                splitTextToSpans(node, clone);
            }
        });
    }

    const titleEl = document.querySelector(".mosaic-title");
    if (titleEl) {
        const clone = titleEl.cloneNode(true);
        titleEl.innerHTML = '';
        splitTextToSpans(clone, titleEl);

        gsap.fromTo(".mosaic-title .char",
            { autoAlpha: 0, y: 30 },
            {
                autoAlpha: 1,
                y: 0,
                duration: 0.6,
                stagger: 0.05, // 0.05秒ずつ順番に出現
                ease: "back.out(1.5)", // 少し弾みをつけてスタイリッシュに
                scrollTrigger: {
                    trigger: ".mosaic-section",
                    start: "top 80%",
                    toggleActions: "play none none reverse"
                }
            }
        );
    }

    gsap.fromTo(".mosaic-item",
        { autoAlpha: 0, y: 50 },
        {
            autoAlpha: 1,
            y: 0,
            duration: 0.8,
            stagger: 0.15, // 0.15秒ずつ遅れて順番に出現
            ease: "power2.out",
            scrollTrigger: {
                trigger: ".mosaic-grid",
                start: "top 85%",
                toggleActions: "play none none reverse"
            }
        }
    );

    // 左右の碇を個別にアニメーション（それぞれのCSSの透明度を尊重させるため）
    const anchors = document.querySelectorAll(".mosaic-anchor");
    anchors.forEach((anchor, index) => {
        // 現在のCSSで設定されている不透明度を取得
        const targetOpacity = window.getComputedStyle(anchor).opacity;

        gsap.fromTo(anchor,
            { opacity: 0, y: 50 },
            {
                opacity: targetOpacity, // スマホなら0.3、PCなら0.9が自動で入る
                y: 0,
                duration: 1.2,
                delay: index * 0.2, // スタッガーの代わりに遅延を入れる
                ease: "power2.out",
                scrollTrigger: {
                    trigger: ".mosaic-section",
                    start: "top 70%",
                    toggleActions: "play none none reverse"
                }
            }
        );
    });

    gsap.to("#ocean-particles", {
        opacity: 0,
        ease: "none",
        scrollTrigger: {
            trigger: ".mosaic-section",
            start: "top bottom",
            end: "center center",
            scrub: true
        }
    });

    window.addEventListener('load', () => {
        ScrollTrigger.refresh();
    });
}

// ページ読み込み時に実行
document.addEventListener('DOMContentLoaded', initTimelineEffects);

// Shopifyテーマエディタでセクションが保存・再描画された時に再実行
document.addEventListener('shopify:section:load', initTimelineEffects);
